<div class="container">
	<div class="modal-header">
		<div class="col-xs-11 col-md-11">
			<h4 class="modal-title fw-bold word-wrap"><span jhiTranslate="germplasm-details.header">Germplasm Details:</span> <span *jhiHasAnyAuthority="VIEW_NAMES_PERMISSION">{{germplasm?.preferredName  | truncateWithEllipsis:MAX_NAME_DISPLAY_SIZE}}</span> (GID: {{germplasm?.gid}})</h4>
		</div>
		<div class="col-xs-1 col-md-1">
			<button type="button" class="btn-close" data-bs-dismiss="modal" aria-hidden="true"
					(click)="clear()">
			</button>
		</div>
	</div>
	<iframe [src]="safeUrl" style="border: 0" width="100%" height="850px"></iframe>
</div>




